/* eslint-disable no-undef */
$(function () {
  // //reload
  // var Dwinsize, Nwinsize;

  // if ( window.innerWidth>1024) {
  //   Dwinsize = true;
  // }else{
  //   Dwinsize = false;
  // }

  // $( window ).resize(function(){
  //   if ( window.innerWidth>1024) {
  //     Nwinsize = true;
  //   }else{
  //     Nwinsize = false;
  //   }

  //   if (Dwinsize != Nwinsize) {
  //     $( window ).off('resize');
  //     window.location.reload()
  //   };
  // })

  // $( "body" ).addClass('index');

  // main nav fixed
  // Hide Header on on scroll down
  var didScroll
  var lastScrollTop = 0
  var delta = 5
  var navbarHeight = $('header').outerHeight()

  $(window).scroll(function (event) {
    didScroll = true
  })

  setInterval(function () {
    if (didScroll) {
      hasScrolled()
      didScroll = false
    }
  }, 250)

  function hasScrolled () {
    var st = $(this).scrollTop()

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) { return }

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $('header.bodyHeader').removeClass('nav-down').addClass('nav-up')
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $('header.bodyHeader').removeClass('nav-up').addClass('nav-down')
      }
    }

    lastScrollTop = st
  }

  // nav hamburger
  // $( ".mainNav_mobile" ).append( "<a href='#0' class='nav_trigger'>Menu<span></span><span></span><span></span><span></span></a>" );
  // var bodyprepend = "<div class='bodyWrapper'>";
  // var bodyappend = "</div>";
  // $( "body" ).prepend( bodyprepend );
  // $( "body" ).append( bodyappend );

  // $( "body" ).wrapInner( "<div class='bodyWrapper'></div>");

  // $('.nav_trigger').click(function(){
  //     $('.nav_trigger').toggleClass('open');
  //     $('.mainNav_mobile').fadeToggle( "slow", "linear" );
  //     $('body, .bodyWrapper').toggleClass('overflowhidden');
  // });

  // search
  $('.sb-search').click(function (e) {
    e.stopPropagation()
    $(this).addClass('sb-search-open')
  })
  $('body').click(function () {
    if ($('.sb-search').hasClass('sb-search-open')) {
      $('.sb-search').removeClass('sb-search-open')
    }
  })

  // header「會員」功能nav
  $('.globalMember').hover(function () {
    $('.memList').stop().slideDown(300)
  }, function () {
    $('.memList').stop().slideUp(300)
  })

  // slick
  $('.slick_list.course').slick({
    infinite: true,
    arrows: true,
    loop: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767,
        settings: 'unslick'
        // settings: {
        //   infinite: false,
        //   arrows: false,
        //   slidesToShow: 2,
        //   slidesToScroll: 1,
        //   variableWidth: true

        // }
      }
    ]
  })

  $('.slick_list.tutor').slick({
    infinite: true,
    arrows: true,
    loop: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767,
        settings: 'unslick'
        // settings: {
        //   infinite: false,
        //   arrows: false,
        //   slidesToShow: 2,
        //   slidesToScroll: 1,
        //   variableWidth: true
        // }
      }
    ]
  })

  // $('.bannerSlider ul').slick({
  //     centerMode: true,
  //     // centerPadding: '10px',
  //     slidesToShow: 3,
  //     variableWidth: true,
  //     speed: 900,
  //     dots: true,
  //     responsive: [
  //         {
  //             breakpoint: 600,
  //             settings: {
  //                 slidesToShow: 1,
  //                 adaptiveHeight: true
  //             }
  //         }
  //     ]
  // });

  /// ///////ScrollMagic
  // var scene = new ScrollMagic.Scene({triggerElement: ".mainNav"})
  //                     .setPin(".mainNav");

  // if ($( window ).width() >= 1025) {
  //     // init controller
  //     var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});
  //     // build scenes
  //     new ScrollMagic.Scene({triggerElement: "#parallax1"})
  //                     .setTween("#parallax1 > div", {y: "80%", ease: Linear.easeNone})
  //                     .addTo(controller);

  //     //主視覺
  //     var tweenAA = new TimelineMax ()
  //     .add([
  //           TweenMax.fromTo(".unit_mainGraphic", 2, {css:{bottom:'-120px'}}, {css:{bottom:'0px'}, ease: Linear.easeNone})
  //     ]);

  //     //build scene and set duration to window height
  //     var scene = new ScrollMagic.Scene({triggerElement: "#trigger", duration: 600})
  //                     .setTween(tweenAA)
  //                     .addTo(controller);
  // };

  // bottomsheet
  // function debounce(fn, delay) {
  //     var timer
  //     return function() {
  //         var context = this
  //         var args = arguments
  //         clearTimeout(timer)
  //         timer = setTimeout(function() {
  //             fn.apply(context, args)
  //         }, delay)
  //     }
  // }

  // $(window).on('resize', debounce(function() {
  //     var windowWidth = $(window).width(); // width of browser viewport
  //     var windowHeight = $(window).height(); // height of browser viewport
  //     var documentHeight = $(document).height(); // height of HTML document
  //     var fadeInPoint = 200; // FromTop
  //     var fadeOutPoint = 400; // FromBottom

  //     if (windowWidth > 1024) {
  //         // console.log('寬大於1024')
  //     } else {
  //         // console.log('寬小於1024')

  //         $(window).scroll(function() {
  //             var windowScrollTop = $(window).scrollTop();
  //             var nowPoint = windowHeight + windowScrollTop;

  //             if ($(this).scrollTop() > fadeInPoint && nowPoint+fadeOutPoint < documentHeight) {
  //                 $("#bottomsheet").fadeIn();
  //                 console.log('超過200')
  //             } else {
  //                 $("#bottomsheet").fadeOut();
  //                 console.log('還沒超過200 或 在底部前400')
  //             }

  //         });
  //     }
  //     $(window).scroll();
  // }));

  // $(window).trigger('resize');

  // $(".top").hide();
  // var documentHeight = $(document).height();
  // var windowHeight = $(window).height();
  // var fromBot = documentHeight - 300 - windowHeight;

  // if ($( window ).width() <= 1024) {
  //     $(window).scroll(function(){
  //         var windowScrollTop = $(document).scrollTop();

  //         if(windowScrollTop > 200 && windowScrollTop < fromBot) {
  //           $("#bottomsheet").fadeIn('show');
  //         } else if(windowScrollTop > fromBot) {
  //           $("#bottomsheet").fadeOut('show');
  //         } else if(windowScrollTop < 200) {
  //           $("#bottomsheet").fadeOut('show');
  //         };
  //     });
  // };

  // scrolltoTop
  // $(window).scroll(function () {
  //     var s = $(this).scrollTop();
  //     var m = 300;

  //     if(s > m) {
  //         $("#pagetop").fadeIn('slow');
  //     } else if(s < m) {
  //         $("#pagetop").fadeOut('slow');
  //     };

  // });

  // $(window).scroll(function () {
  //     var s = $(this).scrollTop();
  //     var m = 300;
  //     if(s > m) {
  //         $("#pagetop,#bottomsheet").fadeIn('slow');
  //     } else if(s < m) {
  //         $("#pagetop,#bottomsheet").fadeOut('slow');
  //     };

  // });

  // $("#pagetop p").click(function () {
  //     $('html,body').animate({ scrollTop: 0 }, 'slow');
  //     return false;
  // });

  // $(".button-group .button").click(function () {
  //     $('html,body').animate({ scrollTop: 200 }, 'slow');
  //     //return false;
  // });

  // 會員登入
  // $(".login .wrap" ).prepend( "<button class='closeBtn'><span>Close</span></button>" );
  // $(".login" ).append( "<a class='overlay'></a>" );

  // $(".globalMember  a .unlogin").click(function () {

  //     $('.login').fadeIn(200).css('display','flex');
  //     $('body, .bodyWrapper').addClass('overflowhidden');
  //     return false;
  // });

  $('.login_udn button').click(function () {
    $('#login_udn').fadeIn(200).css('display', 'flex')
    return false
  })

  $('.login_mobile button').click(function () {
    $('#login_mobile').fadeIn(200).css('display', 'flex')
    return false
  })

  $('.backToMode').click(function () {
    $('.signForm').fadeOut()
    // $('.wrapper').removeClass('noScroll')
  })

  $('.closeBtn , .overlay').click(function () {
    $('.login').fadeOut()
    $('.signForm').fadeOut()
    $('body, .bodyWrapper').removeClass('overflowhidden')
  })
})



// WEBPACK FOOTER //
// ./src/assets/js/function_index.js